import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { MoneyWithDecimals } from '../../../../ui/moneyWithDecimals/';
import { Rate } from '../../../../ui/rate';
import messages from './CreditOutstandingMessage.messages';

export class CreditOutstandingMessage extends Component {
    hasFees() {
        const { approvalStatusFeesBalance } = this.props;
        return approvalStatusFeesBalance > 0;
    }

    renderRateMessage() {
        const { approvalInterestRate } = this.props;

        const values = {
            monthlyInterestRate: <Rate value={approvalInterestRate} />
        };
        return (
            <FormattedMessage
                {...messages.monthlyInterestRate}
                values={values}
            />
        );
    }

    renderAmountMessage() {
        const { approvalStatusFeesBalance, approvalStatusInterestBalance } =
            this.props;

        let values = {
            interestBalance: (
                <MoneyWithDecimals value={approvalStatusInterestBalance} />
            )
        };

        if (this.hasFees()) {
            values.feesBalance = (
                <MoneyWithDecimals value={approvalStatusFeesBalance} />
            );

            return (
                <FormattedMessage
                    {...messages.creditUtilisationOutstandingMessageWithInterestAndFees}
                    values={values}
                />
            );
        }

        return (
            <FormattedMessage
                {...messages.creditUtilisationOutstandingMessageWithInterest}
                values={values}
            />
        );
    }

    render() {
        const { className } = this.props;
        const rateMessage = this.renderRateMessage();
        const amountMessage = this.renderAmountMessage();

        return (
            <span className={className}>
                <div>{rateMessage}</div>
                <div>{amountMessage}</div>
            </span>
        );
    }
}
